module.exports = __webpack_public_path__ + "img/manage.11100a25.svg";